/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Úpravy dokončeny',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Provést úpravy',
  'editor-common-extensibility.macro.button.configure': 'Konfigurovat makro {macroName}',
  'editor.extension.legacyContentHeader': 'Starší obsah',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': 'Tento obsah má omezenou funkčnost,',
  'editor.extension.legacyContentHeader.learnMore': 'Další informace',
  'editor.trackChanges.toolbarIconLabel': 'Sledovat změny',
  'fablric.editor.viewAllInserts': 'Zobrazit všechny vložky',
  'fabric.editor.action': 'Aktuální úkol',
  'fabric.editor.action.description': 'Vytvořit a přiřadit aktuální úkol',
  'fabric.editor.addAltText': 'Alternativní text',
  'fabric.editor.addColumnLeft': 'Přidat sloupec vlevo',
  'fabric.editor.addColumnRight': 'Přidat sloupec vpravo',
  'fabric.editor.addCommentOnMedia': 'Přidat komentář',
  'fabric.editor.addImageBorder': 'Přidat ohraničení',
  'fabric.editor.addLoomVideo': 'Nahrávání videa Loom',
  'fabric.editor.addLoomVideoComment': 'Nahrát videokomentář Loom',
  'fabric.editor.addMediaFiles': 'Přidat obrázek, video nebo soubor',
  'fabric.editor.addRowAbove': 'Přidat řádek nad',
  'fabric.editor.addRowBelow': 'Přidat řádek pod',
  'fabric.editor.addUpdatedAltText': 'Přidejte alternativní text.',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Vyhledejte položky akcí a zobrazte je na panelu pomocí Atlassian Intelligence.',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Panel položek akcí (beta)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Vytvořte souhrn této stránky a zobrazte jej na panelu pomocí Atlassian Intelligence.',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Panel souhrnu stránky (beta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Vybraný obsah',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Generuje obsah, který má být vložen do aktualizace.',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Shrne obsah aktualizace.',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Generovat',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Zeptejte se Atlassian Intelligence.',
  'fabric.editor.ai.config.item.action.edit': 'Upravit',
  'fabric.editor.ai.config.item.action.insert': 'Vložit',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Vložit nahoru',
  'fabric.editor.ai.config.item.action.insertBelow': 'Vložit pod',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': 'Vložit pod originál',
  'fabric.editor.ai.config.item.action.replace': 'Nahradit',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Nahradit název',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Název nesmí mít více znaků než {maxLength}.',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': 'Pokračovat v chatu',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Otevřít v chatu',
  'fabric.editor.ai.config.item.addPolish.description': 'Vypiluje obsah, aby byl uhlazenější.',
  'fabric.editor.ai.config.item.addPolish.title': 'Uhladit',
  'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence – Agent Rovo',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Zkrátí obsah, aby byl stručnější.',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Zkrátit aktualizaci',
  'fabric.editor.ai.config.item.bb.pr.description.description': 'Vytvoří popis pull requestu se souhrnem změn.',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Vytvořit popis pull requestu',
  'fabric.editor.ai.config.item.brainstorm.description': 'Vygeneruje seznam nápadů pro zadané téma.',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Nadhoďte téma…',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorming',
  'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorming',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle': 'Délka',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle': 'Upravit délku',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Změní tón obsahu na neformální.',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Neformální',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Neformální',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Změnit tón na neformální',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Změní tón obsahu na vzdělávací.',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Vzdělávací',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Vzdělávací',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Změnit tón na vzdělávací',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Změní tón obsahu na empatický.',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empatický',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empatický',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Změnit tón na empatický',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Změnit tón na…',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Změní tón obsahu na neutrální.',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutrální',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutrální',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Změnit tón na neutrální',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description': 'Změní tón obsahu na profesionální.',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Profesionální',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Profesionální',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Změnit tón na profesionální',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Změní formát obsahu na odrážkový seznam.',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Převést na odrážkový seznam',
  'fabric.editor.ai.config.item.convertToTable.description': 'Změní formát obsahu na tabulku se záhlavím.',
  'fabric.editor.ai.config.item.convertToTable.title': 'Převést na tabulku',
  'fabric.editor.ai.config.item.draftReply.description':
    'Navrhne odpověď na základě požadavků podobných tomu, na kterém právě pracujete.',
  'fabric.editor.ai.config.item.draftReply.title': 'Navrhnout odpověď',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Opravuje pravopisné a gramatické chyby.',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title': 'Pravopis a gramatika',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Opravit pravopis a gramatiku',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Zlepší zřetelnost, strukturu a tón za účelem větší poutavosti a srozumitelnosti.',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Vylepšit styl',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Vylepšit styl',
  'fabric.editor.ai.config.item.findActionItems.description': 'Vyhledá položky akcí v obsahu, který poskytujete.',
  'fabric.editor.ai.config.item.findActionItems.title': 'Najít položky akcí',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Vyberte si z následujících možností (samočinné generování je v Elevate momentálně zakázáno)',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'Napište pomocí AI nebo vyberte níže.',
  'fabric.editor.ai.config.item.generateEscalationNotes.description':
    'Vygeneruje poznámky k eskalaci na základě kontextu požadavku.',
  'fabric.editor.ai.config.item.generateEscalationNotes.title': 'Vygenerovat poznámky k eskalaci',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Změňte strukturu popisu požadavku na základě typu požadavku.',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Vylepšit popis',
  'fabric.editor.ai.config.item.makeLonger.description': 'Rozšíří obsah na základě kontextu, který poskytnete.',
  'fabric.editor.ai.config.item.makeLonger.title': 'Prodloužit obsah',
  'fabric.editor.ai.config.item.range.agent.description': 'Bez popisu',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    'Řekněte agentovi, aby něco napsal, nebo si vyberte z možností níže.',
  'fabric.editor.ai.config.item.rephrase.description': 'Vytvoří návrh na přepsání vašich vět.',
  'fabric.editor.ai.config.item.rephrase.title': 'Přeformulovat',
  'fabric.editor.ai.config.item.shorten.description': 'Zkrátí obsah, aby byl stručnější.',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Zkrátit',
  'fabric.editor.ai.config.item.shorten.title': 'Zkrátit',
  'fabric.editor.ai.config.item.suggest.description': 'Navrhne název pro obsah, který poskytujete.',
  'fabric.editor.ai.config.item.suggest.title': 'Navrhnout název',
  'fabric.editor.ai.config.item.summarize.description':
    'Vytvoří souhrn textu, na kterém pracujete, a zdůrazní klíčové body.',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Shrnout psaní',
  'fabric.editor.ai.config.item.summarize.title': 'Shrnout psaní',
  'fabric.editor.ai.config.item.translate.czech': 'Čeština',
  'fabric.editor.ai.config.item.translate.danish': 'Dánština',
  'fabric.editor.ai.config.item.translate.dutch': 'Holandština',
  'fabric.editor.ai.config.item.translate.english': 'Czech',
  'fabric.editor.ai.config.item.translate.finnish': 'Finština',
  'fabric.editor.ai.config.item.translate.french': 'Francouzština',
  'fabric.editor.ai.config.item.translate.german': 'Němčina',
  'fabric.editor.ai.config.item.translate.hungarian': 'Maďarština',
  'fabric.editor.ai.config.item.translate.italian': 'Italština',
  'fabric.editor.ai.config.item.translate.japanese': 'Japonština',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Přeložit',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Přeložit do…',
  'fabric.editor.ai.config.item.translate.norwegian': 'Norština',
  'fabric.editor.ai.config.item.translate.russian': 'Ruština',
  'fabric.editor.ai.config.item.translate.spanish': 'Španělština',
  'fabric.editor.ai.config.item.translate.swedish': 'Švédština',
  'fabric.editor.ai.config.item.translate.thai': 'Thaiština',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Přeloží text, na kterém pracujete, do zjednodušené čínštiny.',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Přeložit do zjednodušené čínštiny',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Přeloží text, na kterém pracujete, do tradiční čínštiny.',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Přeložit do tradiční čínštiny',
  'fabric.editor.ai.config.item.translateTo.czech.description': 'Přeloží text, na kterém pracujete, do češtiny.',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Přeložit do češtiny',
  'fabric.editor.ai.config.item.translateTo.danish.description': 'Přeloží text, na kterém pracujete, do dánštiny.',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Přeložit do dánštiny',
  'fabric.editor.ai.config.item.translateTo.dutch.description': 'Přeloží text, na kterém pracujete, do nizozemštiny.',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Přeložit do nizozemštiny',
  'fabric.editor.ai.config.item.translateTo.english.description': 'Přeloží text, na kterém pracujete, do angličtiny.',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Přeložit do angličtiny',
  'fabric.editor.ai.config.item.translateTo.finnish.description': 'Přeloží text, na kterém pracujete, do finštiny.',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Přeložit do finštiny',
  'fabric.editor.ai.config.item.translateTo.french.description': 'Přeloží text, na kterém pracujete, do francouzštiny.',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Přeložit do francouzštiny',
  'fabric.editor.ai.config.item.translateTo.german.description': 'Přeloží text, na kterém pracujete, do němčiny.',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Přeložit do němčiny',
  'fabric.editor.ai.config.item.translateTo.hungarian.description': 'Přeloží text, na kterém pracujete, do maďarštiny.',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Přeložit do maďarštiny',
  'fabric.editor.ai.config.item.translateTo.italian.description': 'Přeloží text, na kterém pracujete, do italštiny.',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Přeložit do italštiny',
  'fabric.editor.ai.config.item.translateTo.japanese.description': 'Přeloží text, na kterém pracujete, do japonštiny.',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Přeložit do japonštiny',
  'fabric.editor.ai.config.item.translateTo.korean.description': 'Přeloží text, na kterém pracujete, do korejštiny.',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Přeložit do korejštiny',
  'fabric.editor.ai.config.item.translateTo.norwegian.description': 'Přeloží text, na kterém pracujete, do norštiny.',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Přeložit do norštiny',
  'fabric.editor.ai.config.item.translateTo.polish.description': 'Přeloží text, na kterém pracujete, do polštiny.',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Přeložit do polštiny',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Přeloží text, na kterém pracujete, do brazilské portugalštiny.',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Přeložit do brazilské portugalštiny',
  'fabric.editor.ai.config.item.translateTo.russian.description': 'Přeloží text, na kterém pracujete, do ruštiny.',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Přeložit do ruštiny',
  'fabric.editor.ai.config.item.translateTo.spanish.description': 'Přeloží text, na kterém pracujete, do španělštiny.',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Přeložit do španělštiny',
  'fabric.editor.ai.config.item.translateTo.swedish.description': 'Přeloží text, na kterém pracujete, do švédštiny.',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Přeložit do švédštiny',
  'fabric.editor.ai.config.item.translateTo.thai.description': 'Přeloží text, na kterém pracujete, do thajštiny.',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Přeložit do thajštiny',
  'fabric.editor.ai.config.item.translateTo.turkish.description': 'Přeloží text, na kterém pracujete, do turečtiny.',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Přeložit do turečtiny',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Přeloží text, na kterém pracujete, do ukrajinštiny.',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Přeložit do ukrajinštiny',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Přeloží text, na kterém pracujete, do vietnamštiny.',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Přeložit do vietnamštiny',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Změnit tón',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Přepsat',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Přeložit',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Název stránky',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Stránka',
  'fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage':
    'Odpověď momentálně nelze vygenerovat kvůli problémům na naší straně. Zkuste to znovu později.',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Při vkládání odpovědi se vyskytl problém. Zavřete dialog a zkuste to znovu.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'Při generování náhledu se vyskytl problém. Zavřete dialog a zkuste to znovu.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'Obdrželi jsme příliš mnoho nedávných žádostí pro Atlassian Intelligence (AI). Zkuste to znovu za pár minut nebo si přečtěte o <link>nadměrném používání AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Načtení odpovědi se nezdařilo. Vaše výzva nebo odpověď překročila limit pro tuto žádost. Zavřete dialog a zkuste to znovu.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'Vyskytly se problémy. Zavřete dialog a zkuste to znovu.',
  'fabric.editor.ai.experience.adfStreamingError': 'Omlouváme se, ale nepodařilo se získat odpověď.',
  'fabric.editor.ai.experience.apiError': 'Získání odpovědi se nezdařilo, zkuste to znovu.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Vaše výzva nebo obsah nemusí být v souladu s našimi zásadami přijatelného používání. Zkontrolujte obojí a v případě potřeby si přečtěte naše <link>Zásady přijatelného používání</link>. Pokud problém přetrvává, zkuste jinou výzvu nebo obsah.',
  'fabric.editor.ai.experience.browseMore.agents': 'Procházet agenty',
  'fabric.editor.ai.experience.cmdPaletteApiError': 'Při generování odpovědi došlo k chybě.',
  'fabric.editor.ai.experience.cmdPaletteAupViolationMessage':
    'Tuto žádost jsme nemohli dokončit, protože není v souladu s našimi <link>zásadami přijatelného používání</link>.',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Chcete svou výzvu zahodit?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Chcete svou odpověď zahodit?',
  'fabric.editor.ai.experience.discardStreamingInDocumennt': 'Zrušit žádost a zahodit odpověď?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError': 'Samočinné generování je v Elevate momentálně zakázáno.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Nyní můžete do výzev vkládat odkazy 🔗 na obsah Jira a Confluence.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Využívá technologii Rovo',
  'fabric.editor.ai.experience.generatingAiResponse': 'Generuje se',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence nedokázala zpracovat vaši žádost, protože váš obsah obsahuje odkazy na obsah omezený HIPAA. Odeberte tyto odkazy a zkuste to znovu.',
  'fabric.editor.ai.experience.inputTooShortError':
    'Obsah je pro souhrn příliš krátký. Přidejte další a zkuste to znovu.',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) neodpovídá. Zkuste to znovu později nebo <link>zkontrolujte stav AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Generuje se',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analýza: Vaše otázka se kontroluje.',
  'fabric.editor.ai.experience.messageTemplateContentSearch': 'Vyhledávání: Počkejte chvilku, než vyhledáme informace.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Vyhledávání: Počkejte chvilku, než prohledáme Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'Vyhledávání: Počkejte chvilku, než prohledáme stránku.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Žádné výsledky',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Atlassian Intelligence nemá v tuto chvíli žádné návrhy. Neváhejte vyzkoušet jinou výzvu nebo obsah.',
  'fabric.editor.ai.experience.showMoreButton': 'Zobrazit více',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Akce',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agenti',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Zdroj znalostí',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Agenti Rovo',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Agenti Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Použijte agenta Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Použít obecné znalosti',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Použít znalosti z vaší organizace',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'Při generování náhledu se vyskytl problém. Zavřete dialog a zkuste to znovu.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage': 'Vyskytly se problémy. Zavřete dialog a zkuste to znovu.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Vložit pod',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Nahradit',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Žádosti o generování obsahu, které odkazují na adresy URL, jsou v beta verzi.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Zvýraznění termínu, akronymu nebo zkratky',
  'fabric.editor.ai.selectionToolbar.define.title': 'Definovat',
  'fabric.editor.ai.telepointer.rovo': 'Rovo',
  'fabric.editor.ai.toolbar.DefineDropdownIconTitle.title': 'Definovat',
  'fabric.editor.ai.toolbar.askAI.title': 'Zeptat se AI',
  'fabric.editor.ai.toolbar.askRovo.title': 'Zeptejte se nástroje Rovo',
  'fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand': "Zeptat se nástroje Rovo {key}+'",
  'fabric.editor.ai.toolbar.askRovoAiSplitButton.label': 'Zeptat se Rovo AI',
  'fabric.editor.ai.toolbar.changeTone.title': 'Změnit tón',
  'fabric.editor.ai.toolbar.changeToneOptions.title': 'Možnosti změny tónu',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Vylepšit styl',
  'fabric.editor.ai.toolbar.improveWriting.tooltip':
    'Požádejte Atlassian Intelligence o zlepšení vybrané části psaného textu.',
  'fabric.editor.ai.toolbar.makeLonger.title': 'Prodloužit obsah',
  'fabric.editor.ai.toolbar.makeShorter.title': 'Zkrátit',
  'fabric.editor.ai.toolbar.moreCasualTone.title': 'Neformálnější',
  'fabric.editor.ai.toolbar.moreEmpatheticTone.title': 'Empatičtější',
  'fabric.editor.ai.toolbar.moreProfessionalTone.title': 'Profesionálnější',
  'fabric.editor.ai.toolbar.moreRovoOptions.label': 'Další možnosti nástroje Rovo',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.spellingAndGrammar.title': 'Opravit pravopis a gramatiku',
  'fabric.editor.ai.toolbar.summarize.title': 'Shrnout',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.translate.title': 'Přeložit',
  'fabric.editor.ai.toolbar.translateOptions.label': 'Možnosti překladu',
  'fabric.editor.ai.toolbar.tryAI.title': 'Vyzkoušejte AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Otevřít Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "Zeptat se AI {key}+'",
  'fabric.editor.alignCenter': 'Zarovnat na střed',
  'fabric.editor.alignImageCenter': 'Zarovnat na střed',
  'fabric.editor.alignImageLeft': 'Zarovnat vlevo',
  'fabric.editor.alignImageRight': 'Zarovnat vpravo',
  'fabric.editor.alignLeft': 'Zarovnat vlevo',
  'fabric.editor.alignRight': 'Zarovnat vpravo',
  'fabric.editor.alignTableCenter': 'Zarovnat na střed',
  'fabric.editor.alignTableLeft': 'Zarovnat vlevo',
  'fabric.editor.alignment': 'Zarovnání textu',
  'fabric.editor.altText': 'Alternativní text',
  'fabric.editor.alttext.validation': 'Vymažte z alternativního textu všechny zvláštní znaky.',
  'fabric.editor.annotationToolbar': 'Panel nástrojů poznámek',
  'fabric.editor.backLink': 'Zpět',
  'fabric.editor.backgroundColor': 'Barva pozadí',
  'fabric.editor.block.menu.codeblock': 'Blok kódu',
  'fabric.editor.block.menu.copy.block': 'Kopírovat blok',
  'fabric.editor.block.menu.copy.link': 'Kopírovat odkaz',
  'fabric.editor.block.menu.delete.block': 'Odstranit',
  'fabric.editor.block.menu.layout': 'Rozvržení',
  'fabric.editor.block.menu.move.down': 'Posunout dolů',
  'fabric.editor.block.menu.move.up': 'Posunout nahoru',
  'fabric.editor.block.menu.paragraph': 'Odstavec',
  'fabric.editor.blockCardUnavailable': 'Vložený odkaz je uvnitř uzlu {node} a jeho zobrazení nelze změnit',
  'fabric.editor.blockControlDelete': 'Odstranit',
  'fabric.editor.blockControlDragHandleMove': 'Přetažením přesunete.',
  'fabric.editor.blockControlDragHandleRearrange': 'Přetažením změnit uspořádání',
  'fabric.editor.blockControlInsert': 'Vložit',
  'fabric.editor.blockControlMoveDown': 'Posunout dolů',
  'fabric.editor.blockControlMoveLeft': 'Posunout doleva',
  'fabric.editor.blockControlMoveRight': 'Posunout doprava',
  'fabric.editor.blockControlMoveUp': 'Posunout nahoru',
  'fabric.editor.blockControlMovedDown': 'Obsah byl posunut dolů.',
  'fabric.editor.blockControlMovedUp': 'Obsah byl posunut nahoru.',
  'fabric.editor.blockDescription': 'Zobrazit další informace o odkazu, včetně souhrnu a akcí',
  'fabric.editor.blockTitle': 'Karta',
  'fabric.editor.blockquote': 'citace',
  'fabric.editor.blockquote.description': 'Vložit citaci',
  'fabric.editor.blockquote2': 'Citace',
  'fabric.editor.bold': 'Tučné',
  'fabric.editor.breakout.resizeCodeBlock': 'Změnit velikost fragmentu kódu',
  'fabric.editor.breakout.resizeElement': 'Změnit velikost prvku',
  'fabric.editor.breakout.resizeExpand': 'Změnit velikost rozbalitelné sekce',
  'fabric.editor.breakout.resizeLayout': 'Změnit velikost rozvržení',
  'fabric.editor.breakoutFullWidthLabel': 'Celá šířka',
  'fabric.editor.breakoutWideWidthLabel': 'Široká',
  'fabric.editor.bug': 'Chyba',
  'fabric.editor.bulletedList': 'Odrážkový seznam',
  'fabric.editor.canNotSortTable': '⚠️ Tabulku se sloučenými buňkami nelze seřadit',
  'fabric.editor.cancelButton': 'Zrušit',
  'fabric.editor.captionPlaceholder': 'Přidejte popisek',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt': 'Přidejte popisek – dvojitým kliknutím zobrazíte náhled.',
  'fabric.editor.cardFloatingControls': 'Možnosti karty',
  'fabric.editor.cellBackground': 'Pozadí buněk',
  'fabric.editor.cellOptions': 'Možnosti buňky',
  'fabric.editor.checkUncheckActionItem': 'Přepnout stav položky akce',
  'fabric.editor.clearAltTextEdit': 'Vymazat alternativní text',
  'fabric.editor.clearCells':
    '{0, plural, one {Vymazat buňku} few {Vymazat buňky} many {Vymazat buňky} other {Vymazat buňky}}',
  'fabric.editor.clearFormatting': 'Odstranit formátování',
  'fabric.editor.clearLink': 'Vymazat odkaz',
  'fabric.editor.clearLinkText': 'Vymazat text',
  'fabric.editor.closeAltTextEdit': 'Zpět',
  'fabric.editor.closeFindReplaceDialog': 'Zavřít',
  'fabric.editor.closeHelpDialog': 'Zavřít dialog nápovědy',
  'fabric.editor.code': 'Kód',
  'fabric.editor.code.on': '{textFormattingOff}, zapnuto formátování kódu',
  'fabric.editor.codeBidiWarningLabel':
    'Obousměrné znaky mění pořadí vykreslování textu. Může to být použito k zakrytí škodlivého kódu.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Zkopírováno!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Kopírovat jako text',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Vypnout obalení',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Zapnout obalení',
  'fabric.editor.codeblock': 'Fragment kódu',
  'fabric.editor.codeblock.description': 'Zobrazit kód se zvýrazněním syntaxe',
  'fabric.editor.collapseNode': 'Sbalit obsah',
  'fabric.editor.collapseTable': 'Sbalit tabulku',
  'fabric.editor.colorPicker.menuLabel': 'Nabídka výběru barvy',
  'fabric.editor.columnDragHandle': 'Možnosti sloupce',
  'fabric.editor.columnMovedLeft': 'Sloupec byl přesunut doleva na pozici {index} z {total}',
  'fabric.editor.columnMovedRight': 'Sloupec byl přesunut doprava na pozici {index} z {total}',
  'fabric.editor.columnSelected': 'Je vybrán sloupec {index} z {total}',
  'fabric.editor.columns': 'Rozvržení',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {Vložit {numberOfColumns} stejný sloupec} few {Vložit {numberOfColumns} stejné sloupce} many {Vložit {numberOfColumns} stejného sloupce} other {Vložit {numberOfColumns} stejných sloupců}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Vložit rozvržení jediného sloupce',
  'fabric.editor.columns.description': 'Uspořádejte svou stránku pomocí oddílů',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {Byl vložen sloupec.} few {Byly vloženy {count} sloupce.} many {Bylo vloženo {count} sloupce.} other {Bylo vloženo {count} sloupců.}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {Sloupec byl odebrán.} few {Byly odebrány {count} sloupce.} many {Bylo odebráno {count} sloupce.} other {Bylo odebráno {count} sloupců.}}',
  'fabric.editor.configFailedToLoad': 'Nepodařilo se načíst',
  'fabric.editor.configPanel.cancel': 'Zrušit',
  'fabric.editor.configPanel.close': 'Zavřít',
  'fabric.editor.configPanel.customSelect.createOption': 'Vytvořit',
  'fabric.editor.configPanel.dateRange.custom.from': 'Od',
  'fabric.editor.configPanel.dateRange.custom.to': 'Do',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Sbalit',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Rozbalit',
  'fabric.editor.configPanel.dateRange.option.custom': 'Vlastní',
  'fabric.editor.configPanel.documentation': 'Dokumentace',
  'fabric.editor.configPanel.errorBoundary.note':
    'Dali jsme vědět týmu. Tuto stránku můžete stále upravovat a publikovat. Také se můžete podívat na konzolu chyb, kde najdete další informace.',
  'fabric.editor.configPanel.errorBoundary.title': 'Něco se pokazilo.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': '„isMultiple“ a „style: radio“ nelze kombinovat',
  'fabric.editor.configPanel.formType.addField': 'Přidat pole',
  'fabric.editor.configPanel.formType.removeField': 'Odebrat pole',
  'fabric.editor.configPanel.help': 'Potřebujete pomoc?',
  'fabric.editor.configPanel.invalid': 'Neplatné pole',
  'fabric.editor.configPanel.required': 'Povinné pole',
  'fabric.editor.configPanel.submit': 'Odeslat',
  'fabric.editor.contextPanel.panelLabel': 'Kontextový panel',
  'fabric.editor.copiedToClipboard': 'Zkopírováno!',
  'fabric.editor.copyToClipboard': 'Kopírovat',
  'fabric.editor.cornerControl': 'Zvýraznit tabulku',
  'fabric.editor.createComment': 'Komentář',
  'fabric.editor.createCommentDisabled':
    'Komentovat můžete pouze text, nadpisy, smajlíky, kalendářní data, zmínky, odkazy a stavy.',
  'fabric.editor.createCommentInvalid': 'Komentovat můžete pouze text a nadpisy',
  'fabric.editor.customPanel': 'Vlastní panel',
  'fabric.editor.customPanel.description': 'Přidejte poznámku se smajlíkem a barevným pozadím.',
  'fabric.editor.datasource.assetsObjects.description':
    'Pomocí vyhledávání a filtrování vložte objekty z Aktiv do Jira Service Management.',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Aktiva',
  'fabric.editor.datasource.confluenceSearch': 'Vložit seznam Confluence',
  'fabric.editor.datasource.confluenceSearch.description':
    'Vložte seznam výsledků vyhledávání z Confluence s použitím rozšířeného vyhledávání, filtrování a konfigurací.',
  'fabric.editor.datasource.jiraIssue': 'Požadavky Jira',
  'fabric.editor.datasource.jiraIssue.description':
    'Vkládání požadavků Jira z Jira Cloud pomocí rozšířeného vyhledávání, filtrování a konfigurací.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Vkládání požadavků Jira z Jira Cloud pomocí rozšířeného vyhledávání, filtrování a konfigurací',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Požadavky Jira',
  'fabric.editor.datasourceAppearanceTitle': 'Sloupec',
  'fabric.editor.datasourceTitle': 'Upravit vyhledávací dotaz',
  'fabric.editor.date': 'Datum',
  'fabric.editor.date.description': 'Přidat datum pomocí kalendáře',
  'fabric.editor.datePickerOpenedAlert':
    'Bylo otevřeno vyskakovací okno editoru kalendářního data, stisknutím klávesy Tab k němu přejdete.',
  'fabric.editor.decision': 'Rozhodnutí',
  'fabric.editor.decision.description': 'Zaznamenávejte rozhodnutí, aby se snadněji sledovala',
  'fabric.editor.decisionPlaceholder': 'Přidat rozhodnutí...',
  'fabric.editor.decreaseElementSize': 'Snížit velikost prvku',
  'fabric.editor.decreaseSize': 'Snížit velikost tabulky nebo multimédia',
  'fabric.editor.defaultAltText': 'Dokument',
  'fabric.editor.delete': 'Odstranit',
  'fabric.editor.description': 'Popis',
  'fabric.editor.displayBlock': 'Zobrazit jako kartu',
  'fabric.editor.displayEmbed': 'Zobrazit jako vložený objekt',
  'fabric.editor.displayInline': 'Zobrazit v řádku',
  'fabric.editor.displayLink': 'Zobrazit jako text',
  'fabric.editor.displayOptionUnavailableInParentNode': 'Tato možnost zobrazení není v uzlu {node} dostupná',
  'fabric.editor.displayText': 'Text k zobrazení',
  'fabric.editor.distributeColumns': 'Rozložení sloupců',
  'fabric.editor.dragHandleZone': 'Aktivovat zónu úchytu k přetažení',
  'fabric.editor.dropPlaceholderLabel': 'Dokument',
  'fabric.editor.ecombedDescription': 'Zobrazit interaktivní náhled odkazu',
  'fabric.editor.edit': 'Upravit',
  'fabric.editor.edit.datasource': 'Upravit vyhledávací dotaz',
  'fabric.editor.edit.searchInput': 'Přidat odkaz',
  'fabric.editor.editAccessTitle': 'Potřebujete přístup k úpravám',
  'fabric.editor.editAltText': 'Upravit alternativní text',
  'fabric.editor.editDatasourceStandalone': 'Upravit',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Upravit vyhledávací dotaz',
  'fabric.editor.editDateText': 'Upravit datum',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Upravit vyhledávací dotaz',
  'fabric.editor.editDropdownEditLinkTitle': 'Upravit odkaz',
  'fabric.editor.editDropdownExpandIconLabel': 'Rozbalit rozevírací nabídku',
  'fabric.editor.editDropdownTriggerTitle': 'Upravit',
  'fabric.editor.editLink': 'Upravit odkaz',
  'fabric.editor.editMode.inviteToEditButton.title': 'Pozvat k úpravám',
  'fabric.editor.editStatusColor': 'Upravit barvu stavu',
  'fabric.editor.editStatusText': 'Upravit stav',
  'fabric.editor.editableContentLabel': 'Upravitelný obsah',
  'fabric.editor.editorHelp': 'Nápověda editoru.',
  'fabric.editor.editors': 'Editoři',
  'fabric.editor.elementBrowser.help': 'Nápověda',
  'fabric.editor.elementInsertSidePanel.title': 'Vložit',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Administrace',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Vše',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Komunikace',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Obsah Confluence',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Vývoj',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Externí obsah',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formátování',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Média',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigace',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Sestavy',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Vizuály a obrázky',
  'fabric.editor.elementbrowser.featured.whiteboard.description': 'Přidejte na svou stránku vizuály pomocí tabule',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Vašemu vyhledávání neodpovídají žádné výsledky',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Zkuste vyhledat jiný termín nebo objevte nové aplikace pro produkty Atlassian.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Prozkoumat Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Vašemu vyhledávání neodpovídají žádné výsledky.} one {Ve výchozím nastavení je k dispozici {count} návrh.} few {Ve výchozím nastavení jsou k dispozici {count} návrhy.} many {Ve výchozím nastavení je k dispozici {count} návrhu.} other {Ve výchozím nastavení je k dispozici {count} návrhů.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Vašemu vyhledávání neodpovídají žádné výsledky.} one {Pro zadaný text je k dispozici {count} návrh.} few {Pro zadaný text jsou k dispozici {count} návrhy.} many {Pro zadaný text je k dispozici {count} návrhu.} other {Pro zadaný text je k dispozici {count} návrhů.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Enter',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Vyhledat',
  'fabric.editor.elementbrowser.sidebar.heading': 'Procházet',
  'fabric.editor.embedTitle': 'Vložit',
  'fabric.editor.embedToBlockCardWarning': 'Zobrazuje se jako karta na malých obrazovkách',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Používejte emoji k vyjádření nápadů 🎉 a emocí 😄',
  'fabric.editor.emptyLink': 'Zadejte odkaz.',
  'fabric.editor.emptySearchResults': 'Nenašli jsme žádné výsledky.',
  'fabric.editor.emptySearchResultsSuggestion': 'Chcete-li procházet vkládací prvky, vyberte možnost {buttonName}.',
  'fabric.editor.epic': 'Epic',
  'fabric.editor.error': 'Chyba',
  'fabric.editor.errorPanel': 'Panel chyb',
  'fabric.editor.errorPanel.description': 'Chyby zobrazit v barevném panelu',
  'fabric.editor.expand': 'Rozbalení',
  'fabric.editor.expand.description': 'Vložit rozbalení',
  'fabric.editor.expandAriaLabel': 'Dejte rozbalenému obsahu název.',
  'fabric.editor.expandDefaultTitle': 'Klikněte sem pro rozbalení...',
  'fabric.editor.expandNode': 'Rozbalit obsah',
  'fabric.editor.expandPlaceholder': 'Dejte rozbalenému obsahu název...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'Vymazání rozšíření {nodeName} způsobí, že všechny k němu připojené položky přestanou fungovat.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Odstraňování',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Vymazat',
  'fabric.editor.extension.deleteElementTitle': 'Odstranit prvek',
  'fabric.editor.extension.sourceNoTitledName': 'tento prvek',
  'fabric.editor.extensions.config-panel.save-indicator': 'Všechny změny jsou vždy automaticky ukládány',
  'fabric.editor.externalExtensionsHeading': 'Aplikace',
  'fabric.editor.externalMediaFile': 'Externí multimediální soubor',
  'fabric.editor.failed_to_upload': 'Nahrání se nezdařilo',
  'fabric.editor.feedbackDialog': 'Poskytnout zpětnou vazbu',
  'fabric.editor.feedbackDialog.description': 'Podělte se s námi o pocity z práce v cloudovém editoru.',
  'fabric.editor.find': 'Najít',
  'fabric.editor.findNext': 'Najít další',
  'fabric.editor.findPrevious': 'Najít předchozí',
  'fabric.editor.findReplaceToolbarButton': 'Najít a nahradit',
  'fabric.editor.fiveColumns': 'Rozvržení 5 sloupců',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Zrušit',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Vymazat také všechny připojené prvky',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 připojený prvek)} few {{name} (+{amount,number} připojené prvky)} many {{name} (+{amount,number} připojeného prvku)} other {{name} (+{amount,number} připojených prvků)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Jste si jistí?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': 'Ovládací prvky plovoucího panelu nástrojů byly otevřeny.',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Plovoucí panel nástrojů',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Možnosti rozvržení',
  'fabric.editor.floatingToolbar.scrollLeft': 'Posunout doleva',
  'fabric.editor.floatingToolbar.scrollRight': 'Posunout doprava',
  'fabric.editor.focusTableResizeHandle': 'Zaměření na úchyt ke změně velikosti tabulky',
  'fabric.editor.fourColumns': 'Rozvržení 4 sloupců',
  'fabric.editor.headerColumn': 'Sloupec záhlaví',
  'fabric.editor.headerRow': 'Řádek záhlaví',
  'fabric.editor.heading1': 'Nadpis 1',
  'fabric.editor.heading1Description': 'Použít pro nadpis nejvyšší úrovně',
  'fabric.editor.heading2': 'Nadpis 2',
  'fabric.editor.heading2Description': 'Použít pro klíčové oddíly',
  'fabric.editor.heading3': 'Nadpis 3',
  'fabric.editor.heading3Description': 'Použít pro pododdíly a nadpisy skupin',
  'fabric.editor.heading4': 'Nadpis 4',
  'fabric.editor.heading4Description': 'Použít pro podnadpisy',
  'fabric.editor.heading5': 'Nadpis 5',
  'fabric.editor.heading5Description': 'Použít pro seskupení položek seznamu',
  'fabric.editor.heading6': 'Nadpis 6',
  'fabric.editor.heading6Description': 'Použít pro nadpis nejnižší úrovně',
  'fabric.editor.headingLink.ascOrderLabel': 'Seřadit sloupec od Z do A',
  'fabric.editor.headingLink.descOrderLabel': 'Zrušit řazení',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Chyba',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Požadavek',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Požadavek',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Stránka',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Story',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Úkol',
  'fabric.editor.headingLink.invalidLabel': '⚠️ Tabulku se sloučenými buňkami nelze seřadit',
  'fabric.editor.headingLink.noOrderLabel': 'Seřadit sloupec od A do Z',
  'fabric.editor.help': 'Nápověda',
  'fabric.editor.help.description': 'Projděte si všechny klávesové zkratky a možnosti markdownu',
  'fabric.editor.helpDialogTips': 'Zmáčkněte {keyMap}, abyste mohli kdykoliv rychle otevřít tento dialog.',
  'fabric.editor.highlight': 'Barva zvýraznění',
  'fabric.editor.highlight.removeColor': 'Odebrat barvu',
  'fabric.editor.highlightColor': 'Přepnout paletu barev zvýraznění',
  'fabric.editor.highlightFloatingToolbar': 'Zvýraznění',
  'fabric.editor.horizontalRule': 'Dílčí příčka',
  'fabric.editor.horizontalRule.description': 'Rozdělit obsah horizontální čárou',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Vložit nebo vyhledat odkaz',
  'fabric.editor.hyperlink.searchLinkAriaDescription': 'Níže se objeví návrhy na základě vámi napsaného textu v poli',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {nebyly nalezeny žádné výsledky} one {{count,number} nalezený výsledek} few {{count,number} nalezené výsledky} many {{count,number} nalezeného výsledku} other {{count,number} nalezených výsledků}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Zobrazený text (volitelné)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Vložit nebo vyhledat odkaz',
  'fabric.editor.image': 'Obrázek',
  'fabric.editor.image.fullWidthLabel': 'Celá šířka',
  'fabric.editor.imageBorderBold': 'Tučné',
  'fabric.editor.imageBorderColor': 'Barva',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Rozevírací seznam s možnostmi barvy ohraničení obrázku',
  'fabric.editor.imageBorderMedium': 'Střední',
  'fabric.editor.imageBorderOptions': 'Možnosti ohraničení',
  'fabric.editor.imageBorderSize': 'Velikost',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': 'Rozevírací seznam s možnostmi velikosti ohraničení obrázku',
  'fabric.editor.imageBorderSubtle': 'Útlé',
  'fabric.editor.improvement': 'Vylepšení',
  'fabric.editor.increaseElementSize': 'Zvýšit velikost prvku',
  'fabric.editor.increaseSize': 'Zvýšit velikost tabulky nebo multimédia',
  'fabric.editor.indent': 'Zvětšit odsazení',
  'fabric.editor.info': 'Informace',
  'fabric.editor.infoPanel': 'Informační panel',
  'fabric.editor.infoPanel.description': 'Zvýraznit informace v barevném panelu',
  'fabric.editor.inlineConfigureLink': 'Konfigurovat odkaz',
  'fabric.editor.inlineDescription': 'Zobrazit odkaz jako vložený text',
  'fabric.editor.inlineGoToLink': 'Přejít na odkaz',
  'fabric.editor.inlineOverlay': 'Konfigurovat',
  'fabric.editor.inlineTitle': 'Vložený',
  'fabric.editor.inputQueryAssistiveTxt':
    'Když jsou k dispozici výsledky automatického dokončování, použijte šipky nahoru a dolů k prohlížení a klávesu Enter k výběru. Uživatelé dotykových zařízení mohou k prohlížení použít dotyk nebo gesta potáhnutí prstem.',
  'fabric.editor.insertColumn': 'Vložit sloupec napravo',
  'fabric.editor.insertColumnDrag': 'Vložit sloupec',
  'fabric.editor.insertMenu': 'Vložit prvky',
  'fabric.editor.insertRightRail.close': 'Zavřít',
  'fabric.editor.insertRightRail.title': 'Vložit',
  'fabric.editor.insertRow': 'Vložit řádek pod',
  'fabric.editor.insertRowDrag': 'Vložit řádek',
  'fabric.editor.insertTableColumn': 'Vložit sloupec tabulky',
  'fabric.editor.insertTableRow': 'Vložit řádek tabulky',
  'fabric.editor.invalidDateError': 'Zadejte platné datum.',
  'fabric.editor.invalidLink': 'Zadejte platný odkaz.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Pozvat týmového kolegu do produktu {productName}} trusted {Pozvat týmového kolegu do produktu {productName}} other {Přidat týmového kolegu do produktu {productName}}}',
  'fabric.editor.italic': 'Kurzíva',
  'fabric.editor.keyboardShortcuts': 'Klávesové zkratky',
  'fabric.editor.layout.columnOption':
    '{count, plural, one {Sloupec} few {{count} sloupce} many {{count} sloupce} other {{count} sloupců}}',
  'fabric.editor.layout.controls.placeholder': '/ pro vložení',
  'fabric.editor.layout.placeholder': 'Přidat obsah',
  'fabric.editor.layout.resizeLayout': 'Změnit velikost rozvržení',
  'fabric.editor.layoutFixedWidth': 'Zpět na zobrazení standardní šířky',
  'fabric.editor.layoutFullWidth': 'Přepnout do zobrazení na celou šířku',
  'fabric.editor.layoutStateFixedWidth': 'Na střed',
  'fabric.editor.layoutStateFullWidth': 'Celá šířka',
  'fabric.editor.layoutStateWide': 'Široká',
  'fabric.editor.layoutWide': 'Přepnout do zobrazení na šířku',
  'fabric.editor.leftSidebar': 'Rozvržení levého bočního panelu',
  'fabric.editor.link': 'Odkaz',
  'fabric.editor.link.description': 'Vložit odkaz',
  'fabric.editor.linkAddress': 'Adresa odkazu',
  'fabric.editor.linkPlaceholder': 'Vložit odkaz',
  'fabric.editor.lists': 'Seznamy',
  'fabric.editor.listsFormat': 'Formátování seznamu',
  'fabric.editor.lockColumns': 'Pevné šířky sloupců',
  'fabric.editor.longEmptyNodePlaceholderText': 'Zadáním znaku / můžete vkládat prvky.',
  'fabric.editor.markdown': 'Snížení',
  'fabric.editor.matchCase': 'Rozlišovat malá a velká písmena',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Šířka multimédia byla snížena na {newMediaWidth,number} pixel.} few {Šířka multimédia byla snížena na {newMediaWidth,number} pixely.} many {Šířka multimédia byla snížena na {newMediaWidth,number} pixelu.} other {Šířka multimédia byla snížena na {newMediaWidth,number} pixelů.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Šířka multimédia byla zvýšena na {newMediaWidth,number} pixel.} few {Šířka multimédia byla zvýšena na {newMediaWidth,number} pixely.} many {Šířka multimédia byla zvýšena na {newMediaWidth,number} pixelu.} other {Šířka multimédia byla zvýšena na {newMediaWidth,number} pixelů.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Velikost multimediálního prvku byla snížena na minimum.',
  'fabric.editor.media.insert.cancel': 'Zrušit',
  'fabric.editor.media.insert.fileTabTitle': 'Soubor',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Tento odkaz na obrázek bohužel nejde přidat. Stáhněte si obrázek a poté jej přetáhněte na stránku.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Tento obrázek kvůli zdrojovým omezením možná nebude viditelný pro ostatní. Zvažte místo toho nahrání souboru.',
  'fabric.editor.media.insert.insert': 'Vložit',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Neplatný odkaz',
  'fabric.editor.media.insert.linkTabTitle': 'Odkaz',
  'fabric.editor.media.insert.loadPreview': 'Načíst náhled',
  'fabric.editor.media.insert.localFileErrorMessage': 'Tento soubor nejde nahrát.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Chyba při nahrávání souboru. Zkontrolujte cestu k souboru nebo síť.',
  'fabric.editor.media.insert.mediaAlt': 'Náhled nahraného obrázku nebo video souboru',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Výběr multimédií',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Vložte odkaz pro nahrání.',
  'fabric.editor.media.insert.upload': 'Nahrát',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Velikost multimediálního prvku byla zvýšena na maximum.',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Změnit velikost',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Zavřít',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'vstup výšky',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Výška',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Maximální šířka {maxWidth} px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Šířka',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Maximální šířka {maxWidth} px',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Převést na pixely',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Přechod z procentuální velikosti na velikost v pixelech',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Odeslat',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Ověření šířky se nezdařilo',
  'fabric.editor.mediaAddLink': 'Přidat odkaz',
  'fabric.editor.mediaFiles': 'Obrázek, video nebo soubor',
  'fabric.editor.mediaFiles.description': 'Přidejte na svou stránku obrázky a další soubory',
  'fabric.editor.mediaGroupDeleteLabel': 'Odstranit',
  'fabric.editor.media_change_mediainline_caption_warn': 'Vložené (popisek se odebere)',
  'fabric.editor.media_change_mediainline_default': 'Vložený',
  'fabric.editor.media_change_mediasingle': 'Původní velikost',
  'fabric.editor.mention': 'Zmínka',
  'fabric.editor.mention.description': 'Zmiňte někoho, abyste jim zaslali oznámení',
  'fabric.editor.mentionNode.label': 'Označený uživatel',
  'fabric.editor.mentionsAddLabel': 'přidat-ikonu',
  'fabric.editor.mentionsIconLabel': 'Zmínka',
  'fabric.editor.mergeCells': 'Sloučit buňky',
  'fabric.editor.moreFormatting': 'Další formátování',
  'fabric.editor.moveColumnLeft':
    '{0, plural, one {Přesunout sloupec vlevo} few {Přesunout sloupce vlevo} many {Přesunout sloupce vlevo} other {Přesunout sloupce vlevo}}',
  'fabric.editor.moveColumnRight':
    '{0, plural, one {Přesunout sloupec vpravo} few {Přesunout sloupce vpravo} many {Přesunout sloupce vpravo} other {Přesunout sloupce vpravo}}',
  'fabric.editor.moveDownDown':
    '{0, plural, one {Přesunout řádek dolů} few {Přesunout řádky dolů} many {Přesunout řádky dolů} other {Přesunout řádky dolů}}',
  'fabric.editor.moveRowUp':
    '{0, plural, one {Přesunout řádek nahoru} few {Přesunout řádky nahoru} many {Přesunout řádky nahoru} other {Přesunout řádky nahoru}}',
  'fabric.editor.navigate.toolbar.askAI': 'Zeptat se AI',
  'fabric.editor.navigate.toolbar.editor': 'Přejít na panel nástrojů editoru',
  'fabric.editor.navigate.toolbar.floating': 'Přejít na plovoucí panel nástrojů',
  'fabric.editor.noPermissionToAddComment':
    '{contentType, select, blogpost {K přidávání komentářů k tomuto příspěvku na blogu nemáte oprávnění.} page {K přidávání komentářů k této stránce nemáte oprávnění.} other {K přidávání komentářů k této stránce nemáte oprávnění.}}',
  'fabric.editor.noResultsFound': 'Žádné výsledky',
  'fabric.editor.noSearchResults': 'Žádné výsledky vyhledávání',
  'fabric.editor.normal': 'Standardní text',
  'fabric.editor.note': 'Poznámka',
  'fabric.editor.notePanel': 'Panel poznámek',
  'fabric.editor.notePanel.description': 'Přidat poznámku do barevného panelu',
  'fabric.editor.numberedColumn': 'Číslovaný sloupec',
  'fabric.editor.off': 'Formátování {formattingType} vypnuto',
  'fabric.editor.on': '{formattingType} zapnuto',
  'fabric.editor.openButtonTitle': 'Otevřený',
  'fabric.editor.openCellOptions': 'Otevřít možnosti buňky',
  'fabric.editor.openLink': 'Otevřít odkaz na nové kartě',
  'fabric.editor.openPreviewPanel': 'Otevřít panel náhledu',
  'fabric.editor.orderedList': 'Číslovaný seznam',
  'fabric.editor.orderedList.description': 'Vytvořit seřazený seznam',
  'fabric.editor.other': 'Jiné…',
  'fabric.editor.outdent': 'Zmenšit odsazení',
  'fabric.editor.overflowMenuViewMore': 'Zobrazit více',
  'fabric.editor.pageActionsLabel': 'Akce stránky',
  'fabric.editor.panel': 'Panel',
  'fabric.editor.panel.backgroundColor': 'Barva pozadí',
  'fabric.editor.panel.custom': 'Vlastní',
  'fabric.editor.panel.emoji': 'Přidat emoji',
  'fabric.editor.panel.panelsGroup': 'Typy panelů',
  'fabric.editor.panelButtonTitle': 'Panel',
  'fabric.editor.pasteOptions': 'Možnosti vložení',
  'fabric.editor.pastePlainText': 'Vložit prostý text',
  'fabric.editor.placeholderAltText': 'Popište tento obrázek alternativním textem',
  'fabric.editor.placeholderText': 'Text placeholderu',
  'fabric.editor.placeholderText.description': 'Vložit na stránku textový zástupný symbol',
  'fabric.editor.placeholderTextPlaceholder': 'Přidat text placeholderu.',
  'fabric.editor.plainText': 'Použít prostý text',
  'fabric.editor.preferencesLink': 'Předvolby odkazů',
  'fabric.editor.previewButtonTitle': 'Náhled',
  'fabric.editor.quickInsert': 'Rychlé vložení',
  'fabric.editor.recordLoomShortTitle': 'Nahrát',
  'fabric.editor.recordVideo': 'Nahrávání videa Loom',
  'fabric.editor.recordVideo.description': 'Nahrávejte a sdílejte svou obrazovku a myšlenky.',
  'fabric.editor.redo': 'Znovu',
  'fabric.editor.remove': 'Odebrat',
  'fabric.editor.removeColumns':
    '{0, plural, one {Odstranit sloupec} few {Odstranit sloupce} many {Odstranit sloupce} other {Odstranit sloupce}}',
  'fabric.editor.removeEmoji': 'Odstranit emoji',
  'fabric.editor.removeImageBorder': 'Odebrat ohraničení',
  'fabric.editor.removeRows':
    '{0, plural, one {Odstranit řádek} few {Odstranit řádky} many {Odstranit řádky} other {Odstranit řádky}}',
  'fabric.editor.replace': 'Nahradit',
  'fabric.editor.replaceAll': 'Nahradit vše',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {{numberOfMatches,number} shoda nahrazena} few {{numberOfMatches,number} shody nahrazeny} many {{numberOfMatches,number} shody nahrazeno} other {{numberOfMatches,number} shod nahrazeno}}',
  'fabric.editor.replaceWith': 'Nahradit textem',
  'fabric.editor.requestToEdit': 'Požádat o oprávnění k úpravě',
  'fabric.editor.requestToEditDescription': 'Když požádáte o přístup, vlastník stránky dostane oznámení.',
  'fabric.editor.requestToEditDismiss': 'Zavřít',
  'fabric.editor.resizeHandle': 'Změnit velikost úchytu',
  'fabric.editor.resultsCount': '{selectedMatchPosition} z {totalResultsCount}',
  'fabric.editor.richText': 'Použít formátovaný text',
  'fabric.editor.rightSidebar': 'Rozvržení pravého bočního panelu',
  'fabric.editor.rowControl': 'Zvýraznit řádek',
  'fabric.editor.rowDragHandle': 'Možnosti řádku',
  'fabric.editor.rowMovedDown': 'Řádek byl přesunut dolů na pozici {index} z {total}',
  'fabric.editor.rowMovedUp': 'Řádek byl přesunut nahoru na pozici {index} z {total}',
  'fabric.editor.rowSelected': 'Je vybrán řádek {index} z {total}',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {Byl vložen řádek.} few {Byly vloženy {count} řádky.} many {Bylo vloženo {count} řádku.} other {Bylo vloženo {count} řádků.}}',
  'fabric.editor.rowsAreRemoved':
    '{count, plural, one {Řádek byl odebrán.} few {Byly odebrány {count} řádky.} many {Bylo odebráno {count} řádku.} other {Bylo odebráno {count} řádků.}}',
  'fabric.editor.saveButton': 'Uložit',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {K dispozici je {itemsLength,number} výsledek vyhledávání. Možnosti můžete procházet pomocí kláves se šipkami nahoru/dolů. Stisknutím klávesy Enter vyberete možnost.} few {K dispozici jsou {itemsLength,number} výsledky vyhledávání. Možnosti můžete procházet pomocí kláves se šipkami nahoru/dolů. Stisknutím klávesy Enter vyberete možnost.} many {K dispozici je {itemsLength,number} výsledku vyhledávání. Možnosti můžete procházet pomocí kláves se šipkami nahoru/dolů. Stisknutím klávesy Enter vyberete možnost.} other {K dispozici je {itemsLength,number} výsledků vyhledávání. Možnosti můžete procházet pomocí kláves se šipkami nahoru/dolů. Stisknutím klávesy Enter vyberete možnost.}}',
  'fabric.editor.selectColumnResize': 'Vybrat sloupec ke změně velikosti',
  'fabric.editor.selectLanguage': 'Vyberte programovací jazyk',
  'fabric.editor.selectTableColumn': 'Vybrat sloupec tabulky',
  'fabric.editor.selectTableRow': 'Vybrat řádek tabulky',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Vybrat aplikaci',
  'fabric.editor.selectionToolbarOverflowMenuTooltip': 'Více možností',
  'fabric.editor.settingsLinks': 'Přejít do předvoleb odkazů',
  'fabric.editor.shortEmptyNodePlaceholderText': '/ pro vložení',
  'fabric.editor.shortcut': 'Textový zástupce',
  'fabric.editor.single': 'Rozvržení jediného sloupce',
  'fabric.editor.singleColumns': 'Rozvržení 1 sloupce',
  'fabric.editor.sortColumnASC': 'Seřadit sloupec A → Z',
  'fabric.editor.sortColumnDESC': 'Seřadit sloupec Z → A',
  'fabric.editor.sortColumnDecreasing': 'Seřadit sestupně',
  'fabric.editor.sortColumnIncreasing': 'Seřadit vzestupně',
  'fabric.editor.splitCell': 'Rozdělit buňku',
  'fabric.editor.status': 'Stav',
  'fabric.editor.status.description': 'Přidat vlastní štítek stavu',
  'fabric.editor.statusEditorLabel': 'Editor stavu',
  'fabric.editor.statusPickerOpenedAlert':
    'Bylo otevřeno vyskakovací okno editoru stavu, stisknutím klávesy Tab k němu přejdete.',
  'fabric.editor.statusPlaceholder': 'Nastavit stav',
  'fabric.editor.story': 'Story',
  'fabric.editor.strike': 'Přeškrtnutí',
  'fabric.editor.subTask': 'Podúkol',
  'fabric.editor.subscript': 'Dolní index',
  'fabric.editor.subscript.off.superscript.on': 'Dolní index vypnutý, horní index zapnutý',
  'fabric.editor.success': 'Úspěch',
  'fabric.editor.successPanel': 'Panel úspěchů',
  'fabric.editor.successPanel.description': 'Přidat tipy do barevného panelu',
  'fabric.editor.superscript': 'Horní index',
  'fabric.editor.superscript.off.subscript.on': 'Horní index vypnutý, dolní index zapnutý',
  'fabric.editor.supportAltText':
    'Alternativní text je užitečný pro lidi, kteří kvůli zrakovým omezením používají čtečky obrazovky.',
  'fabric.editor.table': 'Tabulka',
  'fabric.editor.table.description': 'Vložit tabulku',
  'fabric.editor.tableAlignmentOptions': 'Možnosti zarovnání',
  'fabric.editor.tableFullWidthLabel': 'Celá šířka',
  'fabric.editor.tableHeader.sorting.asc': 'Bylo použito vzestupné řazení',
  'fabric.editor.tableHeader.sorting.default': 'Seřadit sloupec',
  'fabric.editor.tableHeader.sorting.desc': 'Bylo použito sestupné řazení',
  'fabric.editor.tableHeader.sorting.invalid': 'Tabulku se sloučenými buňkami nejde seřadit',
  'fabric.editor.tableHeader.sorting.no': 'U sloupce není použito žádné řazení',
  'fabric.editor.tableOptions': 'Možnosti tabulky',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {Šířka tabulky byla snížena na {newWidth,number} pixel.} few {Šířka tabulky byla snížena na {newWidth,number} pixely.} many {Šířka tabulky byla snížena na {newWidth,number} pixelu.} other {Šířka tabulky byla snížena na {newWidth,number} pixelů.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {Šířka tabulky byla zvýšena na {newWidth,number} pixel.} few {Šířka tabulky byla zvýšena na {newWidth,number} pixely.} many {Šířka tabulky byla zvýšena na {newWidth,number} pixelu.} other {Šířka tabulky byla zvýšena na {newWidth,number} pixelů.}}',
  'fabric.editor.tableScrollRegion': 'Oblast posouvání tabulky',
  'fabric.editor.tableSelector': 'Velikost tabulky',
  'fabric.editor.tableSelector.description': 'Přidejte tabulku a ve vyskakovacím okně vyberte vlastní velikost.',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} × {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Výběr velikosti tabulky',
  'fabric.editor.tables.adjustColumn': 'Upravit sloupec',
  'fabric.editor.tables.columnResizeLast': 'Velikost tohoto sloupce můžete změnit pouze směrem doleva.',
  'fabric.editor.tables.columnResizeOverflow':
    'Velikost tohoto sloupce můžete změnit pouze v případě, že má tabulka posuvník.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Šířka sloupce byla změněna na {width} pixel.} few {Šířka sloupce byla změněna na {width} pixely.} many {Šířka sloupce byla změněna na {width} pixelu.} other {Šířka sloupce byla změněna na {width} pixelů.}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'Odstranění uzlu {nodeName} způsobí, že všechny k němu připojené položky přestanou fungovat.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Odstranit',
  'fabric.editor.tables.resizeStop': 'Změna velikosti byla zastavena.',
  'fabric.editor.tables.resizeTable': 'Změnit velikost tabulky',
  'fabric.editor.tables.startedColumnResize': 'Změna velikosti sloupce byla zahájena.',
  'fabric.editor.task': 'Úkol',
  'fabric.editor.taskDecision.markTaskAsCompleted': 'Označit úkol jako dokončený',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': 'Označit úkol jako nedokončený',
  'fabric.editor.taskList': 'Seznam úloh',
  'fabric.editor.taskPlaceholder': 'Napište svou akci a použitím „@“ ji někomu přidělte.',
  'fabric.editor.text.formatting.off': 'Formátování textu vypnuto',
  'fabric.editor.textColor': 'Barva textu: {selectedColorName}',
  'fabric.editor.textColorHighlightTooltip': 'Barva textu a zvýraznění',
  'fabric.editor.textColorTooltip': 'Barva textu',
  'fabric.editor.textFormat': 'Formátování textu',
  'fabric.editor.textFormatting': 'Formátování textu',
  'fabric.editor.textStyles': 'Styly textu: {blockTypeName}',
  'fabric.editor.textStylesTooltip': 'Styly textu',
  'fabric.editor.threeColumns': 'Rozvržení 3 sloupců',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Rozvržení tří sloupců s levým bočním panelem',
  'fabric.editor.threeColumnsWithRightSidebars': 'Rozvržení tří sloupců s pravým bočním panelem',
  'fabric.editor.threeColumnsWithSidebars': 'Rozvržení tří sloupců s bočními panely',
  'fabric.editor.time.ago': 'zpět',
  'fabric.editor.time.updated': 'Aktualizováno',
  'fabric.editor.time.viewed': 'Zobrazeno',
  'fabric.editor.toolbarAppears': 'Zobrazí se panel nástrojů',
  'fabric.editor.toolbarLabel': 'Editor',
  'fabric.editor.toolbarMediaTitle': 'Přidat obrázek, video nebo soubor',
  'fabric.editor.toolbarPositionFixedAtTop': 'Uchyceno nahoře',
  'fabric.editor.toolbarPositionInline': 'Zarovnáno s textem',
  'fabric.editor.toolbarPositionPinedAtTop': 'Odepnout panel nástrojů',
  'fabric.editor.toolbarPositionUnpined': 'Připnout panel nástrojů v horní části',
  'fabric.editor.toolbarPositionUnpinnedConcise': 'Připnout panel nástrojů v horní části',
  'fabric.editor.tooltip.blockPanel': 'panel',
  'fabric.editor.tooltip.bulletList': 'seznam',
  'fabric.editor.tooltip.decisionList': 'seznam rozhodnutí',
  'fabric.editor.tooltip.defaultBlockNode': 'uzel bloku',
  'fabric.editor.tooltip.nestedExpand': 'vnořený rozbalovací uzel',
  'fabric.editor.tooltip.taskList': 'položka akce',
  'fabric.editor.turnInto': 'Proměnit na',
  'fabric.editor.twoColumns': 'Rozvržení 2 sloupců',
  'fabric.editor.typeAhead.popupLabel': 'Výsledky našeptávače',
  'fabric.editor.typeAhead.quickInsertInputLabel': 'Když začnete psát, budou se vyhledávat/filtrovat možnosti zkratek.',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Vyhledat',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Zkratky pro vkládání a formátování',
  'fabric.editor.typeAheadErrorFallbackDescription': 'Nejsou k dispozici žádné výsledky. Zkuste to znovu.',
  'fabric.editor.typeAheadErrorFallbackHeading': 'Něco se pokazilo',
  'fabric.editor.typeahead.emojiInputLabel': 'Když začnete psát, budou se vyhledávat/filtrovat možnosti smajlíků.',
  'fabric.editor.typeahead.emojiListItemLabel': 'Smajlík {name} Textová zkratka {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Zkratky pro smajlíky',
  'fabric.editor.typeahead.mentionInputLabel': 'Když začnete psát, budou se vyhledávat uživatelé k označení.',
  'fabric.editor.typeahead.mentionPopupLabel': 'Uživatelé, které můžete označit',
  'fabric.editor.typeahead.metionListItemLabel': 'Uživatel {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'Obsah se nepodařilo načíst.',
  'fabric.editor.unableToOpenLink': 'Tento odkaz nelze otevřít',
  'fabric.editor.underline': 'Podtržení',
  'fabric.editor.undo': 'Vrátit',
  'fabric.editor.unknown.label': 'Neznámý',
  'fabric.editor.unlink': 'Zrušit propojení',
  'fabric.editor.unorderedList': 'Seznam s odrážkami',
  'fabric.editor.unorderedList.description': 'Vytvořit neseřazený seznam',
  'fabric.editor.unsupportedBlockContent': 'Tento editor zobrazování tohoto obsahu nepodporuje.',
  'fabric.editor.unsupportedContentTooltip':
    'Obsah není v tomto editoru k dispozici. Vaše úpravy se při uložení zachovají.',
  'fabric.editor.unsupportedInlineContent': 'Nepodporovaný obsah',
  'fabric.editor.upDown':
    'Při použití kláves se šipkami nahoru a dolů v následujícím vstupním poli se aktualizuje datum níže.',
  'fabric.editor.url': 'Zobrazit adresu URL',
  'fabric.editor.urlDescription': 'Zobrazit odkaz jako adresu URL',
  'fabric.editor.urlTitle': 'Adresa URL',
  'fabric.editor.useMarkdown': 'Použít markdown',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Zobrazit a přidat komentáře',
  'fabric.editor.viewCommentOnMedia': 'Zobrazit komentáře',
  'fabric.editor.viewMore': 'Zobrazit více',
  'fabric.editor.viewMoreAriaLabel': 'Zobrazit všechny prvky',
  'fabric.editor.visit': 'Otevřít odkaz v novém okně',
  'fabric.editor.warning': 'Varování',
  'fabric.editor.warningPanel': 'Panel upozornění',
  'fabric.editor.warningPanel.description': 'Přidat poznámku s varováním do barevného panelu',
  'fabric.editor.wrapLeft': 'Sbalit vpravo',
  'fabric.editor.wrapRight': 'Sbalit vlevo',
  'fabric.emoji.label': 'Smajlík',
  'fabric.theme.blue': 'Modrá',
  'fabric.theme.bold-blue': 'Sytě modrá',
  'fabric.theme.bold-gray': 'Sytě šedá',
  'fabric.theme.bold-green': 'Sytě zelená',
  'fabric.theme.bold-magenta': 'Sytě fuchsiová',
  'fabric.theme.bold-orange': 'Sytě oranžová',
  'fabric.theme.bold-purple': 'Sytě purpurová',
  'fabric.theme.bold-red': 'Sytě červená',
  'fabric.theme.bold-teal': 'Sytě modrozelená',
  'fabric.theme.bold-yellow': 'Sytě žlutá',
  'fabric.theme.bolder-blue': 'Sytější modrá',
  'fabric.theme.bolder-gray': 'Sytější šedá',
  'fabric.theme.bolder-green': 'Sytější zelená',
  'fabric.theme.bolder-magenta': 'Sytější fuchsiová',
  'fabric.theme.bolder-orange': 'Sytější oranžová',
  'fabric.theme.bolder-purple': 'Sytější purpurová',
  'fabric.theme.bolder-red': 'Sytější červená',
  'fabric.theme.bolder-teal': 'Sytější modrozelená',
  'fabric.theme.bolder-yellow': 'Sytější žlutá',
  'fabric.theme.dark-blue': 'Tmavě modrá',
  'fabric.theme.dark-gray': 'Tmavě šedá',
  'fabric.theme.dark-green': 'Tmavě zelená',
  'fabric.theme.dark-purple': 'Tmavě purpurová',
  'fabric.theme.dark-red': 'Tmavě červená',
  'fabric.theme.dark-teal': 'Tmavě modrozelená',
  'fabric.theme.dark-yellow': 'Tmavě žlutá',
  'fabric.theme.default': 'Výchozí',
  'fabric.theme.gray': 'Šedá',
  'fabric.theme.green': 'Zelená',
  'fabric.theme.light-blue': 'Světle modrá',
  'fabric.theme.light-gray': 'Světle šedá',
  'fabric.theme.light-green': 'Světle zelená',
  'fabric.theme.light-purple': 'Světle purpurová',
  'fabric.theme.light-red': 'Světle červená',
  'fabric.theme.light-teal': 'Světle modrozelená',
  'fabric.theme.light-yellow': 'Světle žlutá',
  'fabric.theme.lime': 'Limetková',
  'fabric.theme.magenta': 'Fuchsiová',
  'fabric.theme.no-color': 'Bez zvýraznění',
  'fabric.theme.orange': 'Oranžová',
  'fabric.theme.purple': 'Purpurová',
  'fabric.theme.red': 'Červená',
  'fabric.theme.subtle-blue': 'Jemně modrá',
  'fabric.theme.subtle-gray': 'Jemně šedá',
  'fabric.theme.subtle-green': 'Jemně zelená',
  'fabric.theme.subtle-magenta': 'Jemně fuchsiová',
  'fabric.theme.subtle-orange': 'Jemně oranžová',
  'fabric.theme.subtle-purple': 'Jemně purpurová',
  'fabric.theme.subtle-red': 'Jemně červená',
  'fabric.theme.subtle-teal': 'Jemně modrozelená',
  'fabric.theme.subtle-yellow': 'Jemně žlutá',
  'fabric.theme.teal': 'Modrozelená',
  'fabric.theme.white': 'Bílá',
  'fabric.theme.yellow': 'Žlutá',
  'fabrid.editor.rowNumbers': 'Čísla řádků',
  'rovo.agents.dropdown.title': 'Agenti',
  'rovo.agents.dropdown.viewAgents.label': 'Zobrazit všechny agenty',
};
